import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnablePasswordDelete extends RunnableOperation {
  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
  }

  async defineRequest(context: OperationContext): Promise<void> {
    super.defineRequest(context)
    if (this.aborted) {
      throw new Error('Operation aborted')
    }

    context.declareRequestSpec = {
      operationType: 'password.delete',
      pathName: this.userOpSpec.from || '',
    }
  }

  async execute(context: OperationContext): Promise<void> {
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    // Implementa la logica di esecuzione qui
  }

  abort(): void {
    this.aborted = true
  }
}
